module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image06-292eca3bcd914251d4100f1f8a4a475f.jpeg";